import { UserDetailRow } from "~/modals/User/UserDetailsModal/components/UserDetailRow";
import type { Activity } from "~/services/user-events/types";

const formatValue = (value: unknown): string => {
  if (value === null || value === undefined) return "—";
  if (typeof value === "string") return value;

  return JSON.stringify(value);
};

interface DataChangesSectionProps {
  dataChanges: Activity["dataChanges"];
}

export const DataChangesSection = ({
  dataChanges,
}: DataChangesSectionProps) => {
  if (!dataChanges) {
    return <UserDetailRow field="Data Changes" value="—" />;
  }

  const changedFields = Array.from(
    new Set([
      ...Object.keys(dataChanges.old ?? {}),
      ...Object.keys(dataChanges.new ?? {}),
    ]),
  );

  return (
    <UserDetailRow
      field="Data Changes"
      value={
        <div className="flex flex-col gap-2">
          {changedFields.map((field) => (
            <div key={field} className="text-sm">
              <span className="font-medium">{field}: </span>
              {formatValue(dataChanges.old?.[field])}
              {" → "}
              {formatValue(dataChanges.new?.[field])}
            </div>
          ))}
        </div>
      }
    />
  );
};
